
import TableList from "@components/templates/tablelist";
import compSetupAccount from "@components/homepage/homelist/setupaccount";
import { HttpGetAccountList, HttpDelAccount, HttpDisableAccount, HttpActiveAccount, HttpGetAccountInterface, HttpSaveAccountId } from "@/service/managechannel/managechannel";
import { HttpWhAccount } from '@/service/boss/allot';
import { mapState, mapGetters } from "vuex";

import compIndex from './update'
import compAuthorizationtable from './authorizationtable'

export default {
    mixins: [TableList],
    components: {
        compIndex,
        compSetupAccount,
        compAuthorizationtable
    },
    data () {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // EQ_orderStatus:null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            nowdate: ''
        };
    },
    created () {
        this.getNowFormatDate();
        this.accountSet = this.handleAuth('erp.account.set');
        this.accountActive = this.handleAuth('erp.account.active');
    },
    methods: {
        ajaxRequest: HttpGetAccountList,
        handleOperates (params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "create":
                    // this.$router.push({
                    //     name: 'channelUpdate',
                    //     params: { type: "create" },
                    //     query: { id: params },
                    // });
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: this.$t('erp.product.new_add', { defaultValue: "添加" }),
                        component: 'compSetupAccount',
                        width: '800',
                        showFooter: false
                    }
                    break;
                case "addchild":
                    this.$router.push({
                        name: 'channelAddchild',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "addchildvendor":
                    this.$router.push({
                        name: 'channelAddchildVendor',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;

                case "active":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: this.$t('fbb.accountmanage.active_opearte', { defaultValue: "激活操作" }),
                        ajaxRequest: HttpActiveAccount
                    }
                    break;
                case "query":
                    this.operate = {
                        title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
                        show: true,
                        showFooter: false,
                        width: 1200,
                        component: "compIndex",
                        activeids: params.id,
                        querytype: 'query',
                        activedtype: params.type,
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "channelUpdate",
                        params: { type: "query" },
                        query: { id: params.id, type: params.type },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    // const _this = this
                    // setTimeout(function(){
                    // _this.$router.push({
                    //     name: 'channelUpdate',
                    //     params: { type: "edit" },
                    //     query: { id: params.id,type: params.type },
                    // });

                    const { href } = this.$router.resolve({
                        name: 'channelUpdate',
                        params: { type: "edit" },
                        query: { id: params.id, type: params.type },
                    })
                    window.open(href, '_blank')
                    // },500)
                    break;

                case "restore":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: this.$t('erp.channelbase.operate_active', { defaultValue: "恢复操作" }),
                        ajaxRequest: HttpActiveAccount
                    }
                    break;
                case "invalid":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('erp.channelbase.zuofei', { defaultValue: "作废" }),
                        desc: this.$t('erp.channelbase.zuofei_tip', { defaultValue: "作废账号将停止数据抓取,并且原已经抓取数据也无法查看,确认作废该账号?" }),
                        ajaxRequest: HttpDelAccount
                    }
                    break;
                case "disable":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.inactive', { defaultValue: "停用" }),
                        width: 460,
                        desc: this.$t('erp.channelbase.stop_tip', { defaultValue: "注意：点击确认按钮后，数据接口将停用，请谨慎操作！" }),
                        formdata: [
                            {
                                tag: "vDatepicker",
                                key: "inactiveTime",
                                span: 24,
                                style: "width:80%",
                                label: this.$t('erp.channelbase.stop_time', { defaultValue: "停用时间" }),
                                props: {
                                    format: 'yy-mm-dd 00:00:00',
                                    confirm: false,
                                },
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                style: "width:80%",
                                label: this.$t('erp.channelbase.stop_explain', { defaultValue: "停用说明" })
                            },
                        ],
                        params: { id: params },
                        ajaxRequest: HttpDisableAccount
                    }
                    break;
                case "advertising":
                    this.saveAccountId(params)
                    break;
                case "accountinterface":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { channelFlag: params.flag,type:params.type },
                        title: this.$t('erp.channelbase.account_interface', { defaultValue: '店铺重新授权' }),
                        ajaxRequest: HttpGetAccountInterface,
                        callback: (res)=>{
                            if(res.message){
                                window.open(res.message, '_blank');
                            }else{
                                this.$VMessage.error({
                                    content:this.$t('erp.channelbase.accountinterface_tips', { defaultValue: '此平台暂不支持授权' }),
                                    duration:10,
                                    closeable:true,
                                })
                            }
                        },//成功回调函数,

                    }
                    break;
                case "readvertising":
                    this.saveAccountId(params)
                    break;
                case "channelwarehouse":
                    this.getChannelWarehousr(params)
                    break;
                case "deliveryway":
                    var url = this.$router.resolve({
                        name: "manageEditChannel",
                        params: { type: "edit" },
                        query: params,
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/Account/export', { ids: params }, 'download');
                    break;
                case 'download':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/orderPackage/download', { ids: params }, 'download');
                    break;
                case 'authorization':
                    this.operate = {
                        title: this.$t('erp.channelbase.authorization', { defaultValue: '授权' }),
                        show: true,
                        showFooter: false,
                        width: 500,
                        component: "compAuthorizationtable",
                        activejson: params,
                        querytype: 'query',
                    }
                    break;
            }
        },
        saveAccountId (accountid) {
            HttpSaveAccountId({
                accountId: accountid
            }).then(res => {
                const url = "https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.2317edf0077b4a299b6351462fecf852&scope=advertising::campaign_management&response_type=code&redirect_uri=" + process.env.VUE_APP_APIURL_BOSS + "/api/v1/Account/amazon_advertise";
                window.open(url, '_blank');
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closeable: true
                });
            })
        },
        getChannelWarehousr (params) {
            this.loading = true
            HttpWhAccount({ accountId: params.id }).then(res => {
                this.$router.push({
                    name: 'whUpdateAccount',
                    params: { type: "edit" },
                    query: { id: params.id, },
                });
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closeable: true
                });
                let json = {
                    channelCategoryId: params.channelCategoryId,
                    accountId: params.id
                }
                sessionStorage.set('accountJson', JSON.stringify(json))
                if (err.message == '未查询到对应数据') {
                    this.$router.push({
                        name: 'whUpdateAccount',
                        params: { type: "add" },
                    });
                }
            }).finally(res => {
                this.loading = false
            })
        },
        getOperateNodeMap (row) {
            // console.log(row)
            const { id, status, type, flag, title, channelCategoryId, advertisementFlag, isAuthorization } = row;
            return [{
                label: this.$t('erp.channel.active', { defaultValue: '激活' }),
                show: status == 'created' && this.accountActive,
                params: id,
                operate: 'active'
            }, {
                label: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                show: true,
                params: { id, type },
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: status != 'inactive' && this.accountSet,
                params: { id, type },
                operate: 'edit'
            }, {
                label: this.$t('erp.channelbase.recovery', { defaultValue: '恢复' }),
                show: status == 'inactive' || status == 'exceptional',
                params: id,
                operate: 'restore'
            }, {
                label: this.$t('erp.channelbase.zuofei', { defaultValue: '作废' }),
                show: true && this.accountActive,
                params: id,
                operate: 'invalid'
            }, {
                label: this.$t('global.common.inactive', { defaultValue: '停用' }),
                show: status != 'inactive' && this.accountActive,
                params: id,
                operate: 'disable',
            },
            {
                label: isAuthorization == 0 ? this.$t('erp.channelbase.authorization', { defaultValue: '授权' }) : this.$t('erp.channelbase.reauthorization', { defaultValue: '重新授权' }),
                show: (type == 'amazon' || type == 'amazonvendor' || type == 'amazonvendords' || type == 'ebay') && status!= 'inactive',
                params: {id,type,flag},
                operate: 'authorization',
            },
            // {
            //     label: this.$t('erp.channelbase.account_interface', { defaultValue: '店铺重新授权' }),
            //     show: type == 'amazon' || type == 'amazonvendor' || type == 'amazonvendords' || type == 'ebay',
            //     params: { flag, type },
            //     operate: 'accountinterface'
            // },
            {
                label: this.$t('erp.channelbase.adv_interface', { defaultValue: '广告接口授权' }),
                show: (type == 'amazon' || type == "amazonvendor" || type == 'amazonvendords') && advertisementFlag == 0,
                params: id,
                operate: 'advertising'
            },
            {
                label: this.$t('erp.channelbase.adv_interface_reauth', { defaultValue: '广告费接口重新授权' }),
                show: type == 'amazon' && advertisementFlag == 1,
                params: id,
                operate: 'readvertising'
            },
            {
                label: this.$t('erp.channelbase.edit_channel_warehouse', { defaultValue: '编辑渠道仓库' }),
                show: status != 'inactive' && this.accountSet,
                params: { id, channelCategoryId },
                operate: 'channelwarehouse'
            }, {
                label: this.$t('erp.channelbase.edit_channel_send_type', { defaultValue: '编辑渠道发运方式' }),
                show: status != 'inactive' && this.accountSet,
                params: { id, flag, title },
                operate: 'deliveryway'
            }
            ]
        },
        getNowFormatDate () {
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
            this.nowdate = currentdate;
            this.formData.inactiveTime = currentdate + ' 00:00:00'
            // console.log(this.nowdate)
        },
    },
    computed: {
        ...mapState('boss', ['countries', 'allaccounties']),
        orderStatus () {
            return [
                {
                    value: 'created',
                    label: this.$t('erp.distribution.created', { defaultValue: '已创建' }),
                    theme: 'success',
                },
                // // 旧数据用
                // {
                //     value: 'active',
                //     label: this.$t('erp.channelbase.has_active', { defaultValue: '已激活' }),
                //     theme: 'info'
                // },
                {
                    value: 'runing',
                    label: this.$t('erp.channelbase.has_active', { defaultValue: '已激活' }),
                    theme: 'info',
                },
                {
                    value: 'inactive',
                    label: this.$t('erp.channelbase.has_inactive', { defaultValue: '已停用' }),
                    theme: 'warning'
                },
                {
                    value: 'exceptional',
                    label: this.$t('fbb.headlogistics.exception', { defaultValue: '异常' }),
                    theme: 'error',
                },
            ];
        },
        ToolsData () {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: "添加" }),
                    operate: "create",
                    theme: "primary",
                    // batch:true,
                },
                {
                    name: this.$t('erp.channelbase.add_child_account', { defaultValue: "添加子账号" }),
                    operate: "addchild",
                    theme: "warning",
                    // batch:true,
                },
                {
                    name: this.$t('erp.channelbase.add_childvendor_account', { defaultValue: "添加vendor子账号" }),
                    operate: "addchildvendor",
                    theme: "success",
                    // batch:true,
                },
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                    batch: true,
                },
                // {
                //     name: "+Ebay",
                //     operate: "download",
                //     theme: "warning",
                //     show:false,
                //     // batch:true,
                // },
            ]
        },
        statusList () {
            // console.log(this.formData.EQ_flag)
            let a = []
            return a
        },
        SearchsData () {
            const dropStyle = "width:auto;min-width:200px;";
            return [
                {
                    label: this.$t('erp.channelbase.channel_code', { defaultValue: "渠道代码" }),
                    tag: 'vInput',
                    style: "width:180px",
                    key: 'CN_flag',
                    show: true,
                },
                {
                    label: this.$t('erp.channelbase.channel_title', { defaultValue: "渠道标题" }),
                    tag: 'vInput',
                    style: "width:180px",
                    key: 'CN_title',
                    show: true,
                },
                {
                    label: this.$t('erp.channelbase.channel_type', { defaultValue: "渠道类型" }),
                    tag: 'vSelect',
                    style: "width:180px",
                    key: 'EQ_type',
                    options: this.allaccounties.map(function (item) {
                        return {
                            value: item.name,
                            label: item.name
                        }
                    }),
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.channelbase.interface_state', { defaultValue: "接口状态" }),
                    tag: 'vSelect',
                    style: "width:180px",
                    key: 'EQ_status',
                    options: [
                        {
                            value: 'created',
                            label: this.$t('erp.distribution.created', { defaultValue: '已创建 ' })
                        },
                        {
                            value: 'runing',
                            label: this.$t('erp.channelbase.has_active', { defaultValue: '已激活' })
                        },
                        {
                            value: 'inactive',
                            label: this.$t('erp.channelbase.has_inactive', { defaultValue: '已停用' })
                        },
                        {
                            value: 'exceptional',
                            label: this.$t('fbb.headlogistics.exception', { defaultValue: '异常' })
                        },
                    ],
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.channelbase.start_running_time', { defaultValue: "开始运营时间" }),
                    tag: 'vDatepicker',
                    style: "width:180px",
                    key: 'EQ_beginSalesDate',
                    props: {
                        format: 'yy-mm-dd 00:00:00',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: "国家" }),
                    tag: 'vSelect',
                    style: "width:180px",
                    key: 'EQ_countryCode',
                    options: this.countries.map(function (item) {
                        // console.log(item)
                        const { code, nameEn } = item;
                        return {
                            value: code ? code : nameEn,
                            label: code + ' (' + nameEn + ')'
                        }
                    }),
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.channelbase.area', { defaultValue: "区域" }),
                    tag: 'vSelect',
                    style: "width:180px",
                    key: 'EQ_areaCode',
                    options: [
                        {
                            value: 'North America',
                            label: 'North America '
                        },
                        {
                            value: 'Northwest Europe',
                            label: 'Northwest Europe'
                        },
                        {
                            value: 'Oceania',
                            label: 'Oceania '
                        },
                        {
                            value: 'Asia',
                            label: 'Asia'
                        },
                    ],
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.channelbase.sale_type', { defaultValue: "销售方式" }),
                    tag: 'vSelect',
                    style: "width:180px",
                    key: 'EQ_saleType',
                    options: [
                        {
                            value: 'retailer',
                            label: this.$t('erp.b2c.ordertype_normally', { defaultValue: '正常销售 ' })
                        },
                        {
                            value: 'dropship',
                            label: this.$t('erp.channelbase.part_sale_channel', { defaultValue: '分销渠道' })
                        },
                    ],
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },

            ]
        },
        columns () {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: this.$t('global.common.actions', { defaultValue: '操作' }),
                width: 70,
                render: this.getOperateNodes
            }, {
                title: this.$t('erp.channelbase.channel_code', { defaultValue: "渠道代码" }),
                key: 'flag',
                render: (h, { row }) => {
                    return <div>
                        <a onClick={this.handleOperates.bind(this, { id: row.id, type: row.type }, 'query')}>{row.flag}</a>
                        <a onClick={this.handleOperates.bind(this, { id: row.id, type: row.type }, 'queryBlank')}><Icon
                            class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                    </div>
                }
            },
            {
                title: this.$t('erp.channelbase.channel_title', { defaultValue: '渠道标题' }),
                key: 'title',
            },
            {
                title: this.$t('erp.channelbase.channel_type', { defaultValue: '渠道类型' }),
                key: 'type',
                // maxWidth: 100,
            },
            {
                title: this.$t('erp.channelbase.interface_state', { defaultValue: '接口状态' }),
                key: 'status',
                sortable: true,
                // maxWidth: 80,
                render: (h, { row }) => {
                    const status = row.status;
                    const { theme, label } = this.orderStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    console.log();
                    return <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                }
            },
            {
                title: this.$t('erp.channelbase.channel_info', { defaultValue: '渠道信息' }),
                render: (h, { row }) => {
                    return <div>
                        <div>{this.$t('erp.channelbase.first_order', { defaultValue: '首单' })}：{row.beginOrderDate}</div>
                        <div>{this.$t('erp.channelbase.start_running', { defaultValue: '开始运营' })}：{row.beginSalesDate}</div>
                        <div>国家：{row.countryCode}/{row.areaCode}</div>
                        <div v-show={row.type == 'amazon' || row.type == 'amazonvendor' || row.type == 'amazonvendords' || row.type == 'ebay'}>授权状态:{row.isAuthorization == 1 ? '已授权':'未授权'}</div>
                        <div v-show={row.type == 'amazon' || row.type == 'amazonvendor' || row.type == 'amazonvendords'}>广告授权状态：{row.advertisementFlag == 1 ? '已授权' : '未授权'}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                key: 'createdAt',
                sortable: true
            },
            {
                title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                key: 'updatedAt',
                sortable: true
            }
            ];
        },

    },

};
